import { Testimonial } from "content-ui/utilityPages/types";

export default function WhySifted({
  heading,
  testimonials,
}: {
  heading: string;
  testimonials: Testimonial[];
}) {
  return (
    <div className="mb-[70px] md:mb-[43px] lg:mb-[70px]">
      <h2 className="mb-3 font-bold text-[18px]">{heading}</h2>
      <div className="grid grid-cols-1 gap-y-[30px] md:grid-cols-2 md:gap-x-[30px] md:gap-y-[40px] lg:grid-cols-3">
        {testimonials.length &&
          testimonials.map(
            (
              testimonial: { attestantName: string; testimonialText: string },
              i: number
            ) => {
              return (
                <div key={i} className="flex flex-col">
                  <p className="mb-[10px] text-sm leading-[130%] text-mono-40">
                    {testimonial.attestantName}
                  </p>
                  <p className="font-bold text-sm italic leading-[130%]">
                    "{testimonial.testimonialText}"
                  </p>
                </div>
              );
            }
          )}
      </div>
    </div>
  );
}
